import { STAFF_MANDATE_ENABLED } from "../../config/featureFlags";
import TabBar from "./v2/TabBar";
import { Button } from "./v2/buttons";
import { PlusIcon } from "./v2/icons";

// My Agency V2 chrome (ARTBOARD-SPEC CMP-TABS + board 4a tabs+action
// row). PRESENTATION-ONLY restyle: tab keys, per-tab invite handlers and
// the STAFF_MANDATE_ENABLED gating are byte-identical to the previous
// version — only markup/styling changed (Brief Rule 6).
//
// `counts` is optional ({agents, players, staff, partners}); a null /
// undefined value hides that tab's count pill — counts come from state
// that is only populated once a tab's data has loaded (no new count
// endpoints, Brief Rule 8).
const AgencyTabs = ({
  activeTab,
  onTabChange,
  onInviteAgent,
  onInvitePartner,
  onInvitePlayer,
  onInviteStaff,
  counts = {},
}) => {
  const tabs = [
    { key: "agents", label: "Agents", count: counts.agents ?? null },
    { key: "players", label: "Players", count: counts.players ?? null },
    // TP-Coach-Mandate: flag-gated Staff tab. Flag off ⇒ tab absent,
    // existing tabs untouched.
    ...(STAFF_MANDATE_ENABLED
      ? [{ key: "staff", label: "Staff", count: counts.staff ?? null }]
      : []),
    { key: "partners", label: "Partners", count: counts.partners ?? null },
  ];

  // Per-tab action button (labels per artboards 1a "Invite agent",
  // 2c/2j "Add player", 4a "Add partner"; Staff has no artboard — the
  // existing "Invite staff" wording stays).
  const action =
    activeTab === "agents" ? (
      <Button icon={<PlusIcon />} onClick={onInviteAgent}>
        Invite agent
      </Button>
    ) : activeTab === "players" ? (
      <Button icon={<PlusIcon />} onClick={onInvitePlayer}>
        Add player
      </Button>
    ) : STAFF_MANDATE_ENABLED && activeTab === "staff" ? (
      <Button icon={<PlusIcon />} onClick={onInviteStaff}>
        Invite staff
      </Button>
    ) : activeTab === "partners" ? (
      <Button icon={<PlusIcon />} onClick={onInvitePartner}>
        Add partner
      </Button>
    ) : null;

  return (
    <TabBar
      tabs={tabs}
      activeKey={activeTab}
      onChange={onTabChange}
      right={action}
      className="px-6 mt-1"
    />
  );
};

export default AgencyTabs;
